import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { FlotiqApi } from "@jti/rest-api";
import { useTranslations } from "../../providers/useTranslations";
import { StoreLocatorCard } from "../StoreLocator";
import { VerticalLoader } from "../VerticalLoader";
import { StoreDetailsMap } from "./components";
import styles from "./StoreDetails.module.scss";
export const StoreDetails = ({ storeId, isHeaderAddressVisible = true, storeIcons }) => {
    const { __ } = useTranslations();
    const [storeDetails, setStoreDetails] = useState();
    useEffect(() => {
        let ignore = false;
        const flotiqApi = FlotiqApi.init();
        flotiqApi.getStoreById(storeId).then((store) => {
            if (!ignore) {
                const { Street, City, ZipCode } = store;
                setStoreDetails({ ...store, address: [Street, City, ZipCode].filter(Boolean).join(", ") });
            }
        });
        return () => {
            ignore = true;
        };
    }, [storeId]);
    if (!storeDetails) {
        return _jsx(VerticalLoader, { className: styles.loaderContainer, dataTestId: "storeDetailsLoader" });
    }
    return (_jsxs("div", { className: styles.storeDetailsContainer, children: [isHeaderAddressVisible && (_jsxs("div", { className: styles.headerWrapper, children: [_jsx("div", { className: styles.headerSpacer }), _jsx("div", { className: styles.headerRight, children: _jsxs("h1", { className: styles.storeDetailsHeadline, children: [storeDetails.StoreName, " ", storeDetails.Street] }) })] })), _jsxs("div", { className: styles.storeMapContainer, children: [_jsx(StoreLocatorCard, { className: styles.storeDetailsCard, isActive: false, store: storeDetails }), _jsx("div", { className: styles.mapContainer, children: _jsx(StoreDetailsMap, { storeIcons: storeIcons, store: storeDetails }) })] })] }));
};
//# sourceMappingURL=StoreDetails.js.map